// Venue booking form: when "Visit first" is chosen, the space picker is hidden by CSS;
// disabling its fieldset keeps those choices out of the submitted request.
const form = document.getElementById('venue-booking-form');
const spaces = document.getElementById('vb-spaces');
if (form && spaces) {
  const sync = () => {
    spaces.disabled = Boolean(form.querySelector('#vb-mode-visit:checked'));
  };
  form.addEventListener('change', sync);
  sync();
}
